module.exports = __webpack_public_path__ + "media/components/src/assets/images/store-image/mini-568ba406e76c7428856162c11e0ee421.png";